"use strict";
"use server";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var get_server_exports = {};
__export(get_server_exports, {
  getServerSession: () => getServerSession,
  getSessionCookieFromRequest: () => getSessionCookieFromRequest
});
module.exports = __toCommonJS(get_server_exports);
var import_headers = require("next/headers");
var import_constants = require("../constants");
var import_decrypt_session_cookie = require("../lib/cookie/decrypt-session-cookie");
var import_is_api_request = require("../utils/is-api-request");
var import_session = require("../utils/session");
const getSessionCookieFromRequest = async (req) => {
  if ((0, import_is_api_request.isApiRequest)(req)) {
    return req.cookies[import_constants.SESSION_COOKIE_NAME] || "";
  }
  return (await (0, import_headers.cookies)()).get(import_constants.SESSION_COOKIE_NAME)?.value || "";
};
const getServerSession = async (req) => {
  const encryptedCookie = await getSessionCookieFromRequest(req);
  const sessionCookie = await (0, import_decrypt_session_cookie.decryptSessionCookie)(encryptedCookie);
  if (!sessionCookie) return null;
  return (0, import_session.getSessionStateFromSessionCookie)(sessionCookie);
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  getServerSession,
  getSessionCookieFromRequest
});
